<!--
일반검수 레이아웃 (24년 5월버전) >
하우스그룹
------------------------------------
-->
<template>
    <div class="uk-card uk-card-small uk-card-default">
        <controller
            :csrf-token="csrfToken"
            :batch="houseGroup.batch"
            :total-amount="houseGroup.total_amount"
            :house-name="houseGroup.name"
            :house-id="houseGroup.id"
            :house-code="houseGroup.code"
            :house-group="houseGroup"

            :disable-checkbox="disableCheckbox"


            @check:exception="msg => $emit('check:exception', msg)"
            @done:pack="house_id => $emit('done:pack', house_id)"
            @done:ready="$emit('done:ready')"
        >
        </controller>
        <div class="prod-area">




            <prod
                v-for="(prod, index) in houseGroup.prods"
                :key="prod.id"
                :prod="prod"
                :csrf-token="csrfToken"
                :login-user-id="loginUserId"
                :disable-checkbox="disableCheckbox"

                :expensive-limit="expensiveLimit"
                :prod-total-count-in-tracking="houseGroup.prod_total_count_in_tracking"
                :prod-index-in-tracking="index + houseGroup.first_prod_index_in_tracking"

                @done:error="$emit('done:error', null)"
                @done:hold="$emit('done:hold', null)"
                @done:ready="$emit('done:ready', null)"
                @done:pack="house_id => $emit('done:pack', house_id)"
            >
            </prod>

        </div>

    </div>
</template>

<script>
    export default {
        components: {
            'prod': require('./prod.vue').default,
            'controller': require('./controller.vue').default,
        },

        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 로그인 유저 ID
             **/
            loginUserId: {
                type: Number,
                default: null,
            },

            /**
             * 일괄검수용 하우스그룹 객체
             */
            houseGroup: {
                type: Object,
                default: null,
            },

            /**
             * 일괄검수에서
             * 현재 선택된 하우스그룹ID
             */
            activeHouseGroupId: {
                type: Number,
                default: null,
            },

            /**
             * 고가상품 기준가격(현지 currency)
             **/
            expensiveLimit: {
                type: Number,
                default: 200,
            },
        },

        data: function () {
            return {
            };
        },

        computed: {
            /**
             * 체크박스를 disable 처리할지 여부
             */
            disableCheckbox() {
                // 선택된 하우스그룹이 없음
                if (! this.activeHouseGroupId) {
                    return false;
                }

                // 선택된게 있으면 나 자신인 경우만 disable 안함
                return this.houseGroup.id !== this.activeHouseGroupId;
            },
        },

        methods: {
        },
    }
</script>

<style lang="scss" scoped>



    .prod-area {
        //padding: 5px;

        .prod-info {
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0;

            th {
                background-color: #fafafa;
                font-size: 1.25rem;
                text-align: center;
                padding: 10px;
                font-weight: normal;
                border: 1px solid #cfcfcf;

                &.name {
                    text-align: left;

                }

                .uk-checkbox {
                    width: 20px;
                    height: 20px;
                }

                .material-icons {
                    vertical-align: middle;
                    font-size: 28px;
                }

            }

        }
    }
</style>